import { Button, HStack, useColorModeValue } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { useMemo, ReactElement } from 'react';
import {
  ProviderCauseStatusSchema,
  type ProviderCauseStatus,
} from '@duke-hq/svc-api-db/schemas/enums/ProviderCauseStatus.schema';
import { SortOrder } from '@duke-hq/lib/pagination';

interface SortFilters {
  orderBy: string | undefined;
  sort: SortOrder | undefined;
  page: string | undefined;
  status: ProviderCauseStatus | undefined;
}

interface CausesFilterButtonsProps {
  filters: SortFilters;
  onFilterChange: (filters: Partial<SortFilters>) => void;
}

export function CausesFilterButtons({
  filters,
  onFilterChange,
}: CausesFilterButtonsProps): ReactElement {
  const activeTabBg = useColorModeValue('purple.100', 'purple.50');
  const currentStatus = filters.status;

  const filterOptions = useMemo(
    () => [
      { label: t`Active`, status: ProviderCauseStatusSchema.enum.APPROVED },
      { label: t`All`, status: undefined },
      { label: t`Suggestions`, status: ProviderCauseStatusSchema.enum.PENDING },
      { label: t`Archive`, status: ProviderCauseStatusSchema.enum.ARCHIVED },
    ],
    [],
  );

  const handleFilterClick = (status: ProviderCauseStatus | undefined) => {
    onFilterChange({ status, page: undefined });
  };

  return (
    <HStack spacing={2}>
      {filterOptions.map((option) => {
        const isActive = currentStatus === option.status;

        return (
          <Button
            key={
              option.status !== undefined && option.status !== null
                ? option.status.toString()
                : 'all'
            }
            size="xs"
            variant="tertiary"
            onClick={() => handleFilterClick(option.status)}
            bg={isActive ? activeTabBg : 'transparent'}
            color={isActive ? 'fg.accent' : 'inherit'}
            _hover={{
              bg: isActive ? activeTabBg : 'gray.100',
            }}
            borderRadius="md"
          >
            {option.label}
          </Button>
        );
      })}
    </HStack>
  );
}
